import { Node, } from "@siteimprove/alfa-dom";
/**
 * @public
 */
export var Source;
(function (Source) {
    class Data {
        static of(text) {
            return new Data(text);
        }
        _text;
        constructor(text) {
            this._text = text;
        }
        get type() {
            return "data";
        }
        get text() {
            return this._text;
        }
        equals(value) {
            return value instanceof Data && value._text.equals(this._text);
        }
        *[Symbol.iterator]() {
            yield this._text;
        }
        toJSON() {
            return {
                type: "data",
                text: this._text.path(),
            };
        }
    }
    Source.Data = Data;
    function data(text) {
        return Data.of(text);
    }
    Source.data = data;
    class Descendant {
        static of(element, name) {
            return new Descendant(element, name);
        }
        _element;
        _name;
        constructor(element, name) {
            this._element = element;
            this._name = name;
        }
        get type() {
            return "descendants";
        }
        get element() {
            return this._element;
        }
        get name() {
            return this._name;
        }
        equals(value) {
            return (value instanceof Descendant &&
                value._element.equals(this._element) &&
                value._name.equals(this._name));
        }
        *[Symbol.iterator]() {
            yield this._element;
            yield* this._name.sourceNodes();
        }
        toJSON() {
            return {
                type: "descendant",
                element: this._element.path(Node.flatTree),
                name: this._name.toJSON(),
            };
        }
    }
    Source.Descendant = Descendant;
    function descendant(element, name) {
        return Descendant.of(element, name);
    }
    Source.descendant = descendant;
    class Ancestor {
        static of(element, name) {
            return new Ancestor(element, name);
        }
        _element;
        _name;
        constructor(element, name) {
            this._element = element;
            this._name = name;
        }
        get type() {
            return "ancestor";
        }
        get element() {
            return this._element;
        }
        get name() {
            return this._name;
        }
        equals(value) {
            return (value instanceof Ancestor &&
                value._element.equals(this._element) &&
                value._name.equals(this._name));
        }
        *[Symbol.iterator]() {
            yield this._element;
            yield* this._name.sourceNodes();
        }
        toJSON() {
            return {
                type: "ancestor",
                element: this._element.path(),
                name: this._name.toJSON(),
            };
        }
    }
    Source.Ancestor = Ancestor;
    function ancestor(element, name) {
        return Ancestor.of(element, name);
    }
    Source.ancestor = ancestor;
    class Label {
        static of(attribute) {
            return new Label(attribute);
        }
        _attribute;
        constructor(attribute) {
            this._attribute = attribute;
        }
        get type() {
            return "label";
        }
        get attribute() {
            return this._attribute;
        }
        equals(value) {
            return value instanceof Label && value._attribute.equals(this._attribute);
        }
        *[Symbol.iterator]() {
            yield this._attribute;
        }
        toJSON() {
            return {
                type: "label",
                attribute: this._attribute.path(),
            };
        }
    }
    Source.Label = Label;
    function label(attribute) {
        return Label.of(attribute);
    }
    Source.label = label;
    class Reference {
        static of(attribute, name) {
            return new Reference(attribute, name);
        }
        _attribute;
        _name;
        constructor(attribute, name) {
            this._attribute = attribute;
            this._name = name;
        }
        get type() {
            return "reference";
        }
        get attribute() {
            return this._attribute;
        }
        get name() {
            return this._name;
        }
        equals(value) {
            return (value instanceof Reference && value._attribute.equals(this._attribute));
        }
        *[Symbol.iterator]() {
            yield this._attribute;
            yield* this._name.sourceNodes();
        }
        toJSON() {
            return {
                type: "reference",
                attribute: this._attribute.path(),
                name: this._name.toJSON(),
            };
        }
    }
    Source.Reference = Reference;
    function reference(attribute, name) {
        return Reference.of(attribute, name);
    }
    Source.reference = reference;
})(Source || (Source = {}));
//# sourceMappingURL=source.js.map